import React from "react"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import Col from "@bappweb/col"
import Row from "@bappweb/row"
import "../assets/style.scss"

const LandingHeader = () => {
  return (
    <Block type="header" className="landing-header-container landing-header-container-red">
      <Row>
        <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
          <div className="bapp-container">
            <Block className="landing-header-text-wrapper">
              <Block className="landing-header-text">
                <Element type="h1" className="header-text1">
                  {"Akbank 1e1 Bankacılık'ın ayrıcalıklı hizmetleri için biz sizi arayalım."}
                </Element>
                <Element type="p" className="header-text2">
                  {
                    "Akbank 1e1 Bankacılık her türlü finansal ihtiyacınız için size özel ayrıcalıklı hizmetler sunan, bankacılık ürünlerinde çeşitli avantajlar ve finansal bilgilendirme sağlayan hizmetler bütünüdür."
                  }
                </Element>
                <Element type="li" className="header-text2">
                  {
                    "1e1 Bankacılık Yöneticiniz bilgi birikimi, deneyimi ve yakın ilgi, sınırsız güven ilkesiyle sizi yakından tanır, beklentilerinizi anlar ve her türlü finansal ihtiyacınız için size özel çözümler sunar."
                  }
                </Element>
                <Element type="li" className="header-text2">
                  {
                    "Yatırım hakkında tek bilmeniz gereken: Akbank Yatırım Hizmetleri! Yatırımcı profilinize ve değişen piyasa koşullarına uygun alternatifler Ak Portföy ve Ak Yatırım uzmanlığı ile Akbank 1e1 Bankacılık'ta!"
                  }
                </Element>
                <Element type="li" className="header-text2">
                  {"Akbank Mobil ile ayrıcalıklı bir deneyim yaşayın."}
                </Element>
              </Block>
            </Block>

            <Image
              path={"./img/birebirbankaciliklead/bire-bir-bankacilik.png"}
              className="landing-header-img"
            />
          </div>
        </Col>
      </Row>
    </Block>
  )
}

export default LandingHeader
